// Need to use the React-specific entry point to import createApi
import { TbCookieMan } from "react-icons/tb";
import { baseApi } from "./baseApi";

// using CSRF token from Local Storage

// Define a service using a base URL and expected endpoints
export const filterListApi = baseApi.injectEndpoints({
  credentials: "include",
  endpoints: (builder) => ({
    getTransporterList: builder.query({
      query: (query) => {
        // let queryString = new URLSearchParams(query).toString();
        return {
          // url: `transporter?${queryString}`,
          url: `transporter?is_paginate=false`,
          method: "GET",
        };
      },
      transformResponse: (response) => {
        const list = response.data
          .filter((item) => item.name && item.name.trim() !== "")
          .map((item) => ({
            value: item.id,
            label: item.name,
          }));
        return [{ value: "all", label: "All Transporters" }, ...list];
      },
      // keepUnusedDataFor: 300,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
    getSchoolList: builder.query({
      query: (query) => {
        // let queryString = new URLSearchParams(query).toString();
        return {
          // url: `transporter?${queryString}`,
          url: `school?is_paginate=false`,
          method: "GET",
        };
      },
      transformResponse: (response) => {
        const list = response.data
          .filter((item) => item.name && item.name.trim() !== "")
          .map((item) => ({
            value: item.id,
            label: item.name,
          }));
        return [{ value: "all", label: "All Schools" }, ...list];
      },
      // keepUnusedDataFor: 300,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
    getStudentList: builder.query({
      query: (query) => {
        // let queryString = new URLSearchParams(query).toString();
        return {
          // url: `transporter?${queryString}`,
          url: `student?is_paginate=false`,
          method: "GET",
        };
      },
      transformResponse: (response) => {
        const list = response.data
          .filter((item) => item.name && item.name.trim() !== "")
          .map((item) => ({
            value: item.id,
            label: item.name,
          }));
        return [{ value: "all", label: "All Students" }, ...list];
      },
      // keepUnusedDataFor: 300,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
    getDriverList: builder.query({
      query: (query) => {
        // let queryString = new URLSearchParams(query).toString();
        return {
          // url: `transporter?${queryString}`,
          url: `driver?is_paginate=false`,
          method: "GET",
        };
      },
      transformResponse: (response) => {
        const list = response.data
          .filter((item) => item.name && item.name.trim() !== "")
          .map((item) => ({
            value: item.id,
            label: item.name,
          }));
        return [{ value: "all", label: "All Drivers" }, ...list];
      },
      // keepUnusedDataFor: 300,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetTransporterListQuery,
  useGetSchoolListQuery,
  useGetStudentListQuery,
  useGetDriverListQuery,
} = filterListApi;
